export enum KeycardType {
  'AXESS' = 'AXESS',
  'AXESS_DESTINATION' = 'AXESS_DESTINATION',
  'SKIDATA' = 'SKIDATA',
  'NO_KEYCARD' = 'NO_KEYCARD',
  'SWISS_PASS' = 'SWISS_PASS',
}
